module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"radio-filter:accept":"Применить"},"en":{"radio-filter:accept":"Accept"}}')
  delete Component.options._Ctor
}
